/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Url_InvalidInputs */

const vi_error_shop_url_invalid = /** @type {(inputs: Error_Shop_Url_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link phải bắt đầu bằng http:// hoặc https:// và không có dấu cách.`)
};

/**

* @param {Error_Shop_Url_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_url_invalid = /** @type {((inputs?: Error_Shop_Url_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Url_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_url_invalid(inputs)
});